import { render, staticRenderFns } from "./cdgyzyjsxy.vue?vue&type=template&id=545398db&scoped=true&"
import script from "./cdgyzyjsxy.vue?vue&type=script&lang=js&"
export * from "./cdgyzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./cdgyzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdgyzyjsxy.vue?vue&type=style&index=1&id=545398db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545398db",
  null
  
)

export default component.exports